import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Reveal from '../components/Reveal';

const degrees = [
  {
    degree: 'MSc Computer Science — Distributed Software Systems',
    institution: 'Technische Universität Darmstadt',
    period: '2015 — 2019',
    location: 'Darmstadt, Germany',
    current: true,
    description:
      'Advanced studies in distributed systems and scalable software architectures. Thesis: an automated exam grader using machine learning and computer vision.',
    link: { label: 'Thesis on GitHub ↗', url: 'https://github.com/mujahidmasood/automated-exam-grader' }
  },
  {
    degree: 'BSc Computer Science',
    institution: 'National University of Computer and Emerging Sciences (FAST-NUCES)',
    period: '2007 — 2011',
    location: 'Islamabad, Pakistan',
    description:
      'Graduated with honors. Served as teaching assistant for introductory programming courses and competed in programming competitions.'
  }
];

type Cert = { title: string; issuer: string; year: string; skills: string[]; link?: string };

const certifications: Cert[] = [
  {
    title: 'Introducing Generative AI with AWS',
    issuer: 'Udacity',
    year: '2025',
    skills: ['Generative AI', 'AWS', 'LLMs'],
    link: 'https://www.udacity.com/certificate/e/0efbfc2c-3c5d-11f0-a16a-63db3f83b502'
  },
  {
    title: 'DevOps on AWS Specialization',
    issuer: 'Coursera / Amazon Web Services',
    year: '2023',
    skills: ['AWS', 'Infrastructure as Code', 'CI/CD']
  },
  {
    title: 'AI Programming with Python',
    issuer: 'Udacity',
    year: '2017',
    skills: ['Python', 'NumPy', 'Neural Networks']
  },
  {
    title: 'Data Structures and Algorithms',
    issuer: 'Udacity',
    year: '2017',
    skills: ['Algorithms', 'Data Structures', 'Problem Solving']
  },
  {
    title: 'IBM Business Process Manager Certified Developer',
    issuer: 'IBM',
    year: '2014',
    skills: ['IBM WebSphere', 'BPMN', 'Process Automation']
  }
];

const Education: React.FC = () => (
  <IonPage>
    <IonContent>
      <SiteNav current="/education" />
      <main className="page">
        <Reveal>
          <p className="eyebrow"><em>cat</em> ~/education.md</p>
          <h1 className="display" style={{ fontSize: 'clamp(1.9rem, 5vw, 3rem)' }}>
            Education &amp; certifications
          </h1>
        </Reveal>

        <div className="timeline" style={{ marginTop: '3rem' }}>
          {degrees.map((d, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className={`tl-item${d.current ? ' tl-item--current' : ''}`}>
                <div className="tl-item__head">
                  <div className="tl-item__headline">
                    <h2 className="tl-item__title">{d.degree}</h2>
                    <p className="tl-item__org">{d.institution}</p>
                  </div>
                  <div className="tl-item__meta">
                    <em>{d.period}</em>
                    {d.location && <span>{d.location}</span>}
                  </div>
                </div>
                <p className="tl-item__desc">{d.description}</p>
                {d.link && (
                  <div className="card__links">
                    <a className="card__link" href={d.link.url} target="_blank" rel="noreferrer">
                      {d.link.label}
                    </a>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <section className="section" style={{ marginTop: '4rem' }}>
          <Reveal>
            <p className="section-label"><em>ls</em> ~/certifications/</p>
          </Reveal>
          <div className="card-grid">
            {certifications.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.08}>
                <div className="card card--accent" style={{ height: '100%' }}>
                  <span className="card__kicker">{c.year}</span>
                  <h2 className="card__title">{c.title}</h2>
                  <p className="card__body">{c.issuer}</p>
                  <div className="chips">
                    {c.skills.map((s, j) => (
                      <span className="chip" key={j}>{s}</span>
                    ))}
                  </div>
                  {c.link && (
                    <div className="card__links">
                      <a className="card__link" href={c.link} target="_blank" rel="noreferrer">
                        verify ↗
                      </a>
                    </div>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        <SiteFooter />
      </main>
    </IonContent>
  </IonPage>
);

export default Education;
